angular.module 'zc.projects'

.directive 'zcClearanceItemList', ($stateParams, Campaign, Devise, ClearanceItemSet) ->
  restrict: "E"
  scope:
    project: "="
    clearanceItemSet: "="
  templateUrl: "/templates/projects.clearance/clearance_item_list.html"

  link: (scope, element, attrs) ->
    scope.clearanceItemSetItems = []
    scope.countPerLoad = scope.visibleItemCount = 30
    scope.Devise = Devise

    ClearanceItemSet.getItems
      projectId: scope.project.id
      id: scope.clearanceItemSet.id
    .then (res) ->
      scope.clearanceItemSetItems = res

    Campaign.all
      projectId: scope.project.id
      clearance_item_set_id: scope.clearanceItemSet.id
    .then (campaigns) ->
      scope.clearanceItemSet.clearanceCampaigns = campaigns



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.clearance/clearance_item_list.directive.coffee